import * as service from './service'
import { HTTP_CODE } from '@/utils/request'

export default {
  namespace: 'shansongValueScoreList',
  state: {
    demoData: {}
  },
  effects: {
    * getScoreList ({ payload }, { call, put }) {
      const res = yield call(service.getScoreList, payload)
      if (res.data.status !== HTTP_CODE.success) {
        throw new Error(res.data.err)
      }
      return res.data
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
